import { Button, Card, Col, Menu, MenuProps, Row, Typography } from 'antd'
import Title from 'antd/es/typography/Title'
import Sider from 'antd/lib/layout/Sider'
import { MarketplaceIcon } from 'assets/icons/MarketPlaceIcon'
import { UserRoleEnum } from 'enums'
import { Link } from 'react-router-dom'
import {
  ArrowIcon,
  DashboardIcon,
  InvoicesIcon,
  ScopesIcon,
  SettingsIcon,
  SubscriptionsIcon,
  SystemsIcon,
  TenantsIcon,
  UsersIcon,
} from '../assets/icons'
import moon from '../assets/images/moon.png'
import rockets from '../assets/images/rockets.png'
import { history } from '../utils/history'

export interface RWDSidebarProps extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  role: UserRoleEnum
  className: string
  closeNav: () => void
}

enum StyledLinkType {
  GROUP = 'GROUP',
  SINGLE = 'SINGLE',
}

export function SupportSection() {
  return (
    <div className='px-2 pt-3 mt-auto'>
      <Row gutter={15} align='middle' className='rounded' style={{ backgroundColor: '#e5e5ff', padding: 12 }}>
        <Col className='d-flex justify-content-start p-0  h-[50px]'>
          <div className='px-3 py-2 h-full  rounded-md flex items-center fs-4 bg-[#734d9f]'>
            <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' width='24' height='24'>
              <path fill='none' d='M0 0h24v24H0z' />
              <path
                fill='white'
                d='M6.455 19L2 22.5V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H6.455zM7 10v2h2v-2H7zm4 0v2h2v-2h-2zm4 0v2h2v-2h-2z'
              />
            </svg>
          </div>
        </Col>
        <Col flex={'auto'}>
          <Typography.Text type='secondary' style={{ fontSize: 12 }}>
            Support
          </Typography.Text>
          <Typography style={{ fontSize: 12 }} className='text-[#3a3985]'>
            Send a message
          </Typography>
        </Col>
        <Col>
          <Button className='px-1 py-2 d-flex align-items-center border-0 fs-5 bg-transparent'>
            {/* <RightSquareOutlined style={{ color: "#57598f" }} /> */}
          </Button>
        </Col>
      </Row>
    </div>
  )
}
export function CreateReportsWithSaas() {
  return (
    <div className=''>
      <Card
        className='p-0 cardss rounded-xl	'
        style={{
          backgroundColor: '#2b2a63',
          height: 200,
        }}
      >
        <div
          className='p-0 rounded-xl	'
          style={{
            backgroundColor: '#2b2a63',
            position: 'relative',
            height: 200,
            borderRadius: '20',
            overflow: 'hidden',
            width: '100%',
          }}
        >
          <div
            className='circle1'
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              height: 200,
              width: '100%',
              backgroundColor: '#31316f',
            }}
          ></div>
          <div
            className='circle2'
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              height: 200,
              width: '100%',
              backgroundColor: '#3a3985',
            }}
          >
            <div
              className=''
              style={{
                position: 'absolute',
                left: 20,
                bottom: 0,
                height: 100,
                width: '100%',
                textAlign: 'start',
              }}
            >
              <Title level={4} className='text-white'>
                Create Reports
                <br />
                with Saas
              </Title>
              <Typography.Text className='text-white'>Create Reports with Saas</Typography.Text>
            </div>
          </div>
        </div>
        <img
          src={rockets}
          alt=''
          width={70}
          height={70}
          style={{
            position: 'absolute',
            top: -20,
            left: 20,
          }}
        ></img>
        <img
          src={moon}
          className='img-fluid p-3'
          alt=''
          width={90}
          height={90}
          style={{ position: 'absolute', top: 0, right: 0 }}
        ></img>
      </Card>
    </div>
  )
}

export const RWDSidebar = (props: any) => {
  const handleClick = (path: string) => {
    history.push(path)
    props.closeNav()
  }

  const StyledLink: React.FC<{ to: string; children: JSX.Element | string; type?: StyledLinkType }> = ({
    children,
    to,
    type = StyledLinkType.SINGLE,
  }) => (
    <Link
      className={`text-[16px] rounded-lg  no-underline text-black  pl-[15px] ${
        type === StyledLinkType.SINGLE && 'hover:fill-rw-color'
      }`}
      to={to}
      onClick={() => handleClick(to)}
    >
      {children}
    </Link>
  )

  const adminRoutes = [
    {
      label: <StyledLink to={'/admin/dashboard'}>Dashboard</StyledLink>,
      icon: <DashboardIcon />,
      itemIcon: <ArrowIcon />,
      key: 'dashboard',
    },
    {
      label: <StyledLink to={'/admin/tenants'}>Customers</StyledLink>,
      icon: <TenantsIcon />,
      itemIcon: <ArrowIcon />,
      key: 'tenants',
    },
    {
      label: <StyledLink to={'/admin/subscriptions'}>Subscriptions</StyledLink>,
      icon: <SubscriptionsIcon />,
      itemIcon: <ArrowIcon />,
      key: 'subscriptions',
    },

    {
      label: <StyledLink to={'/admin/users'}>Users</StyledLink>,
      icon: <UsersIcon />,
      itemIcon: <ArrowIcon />,
      key: 'users',
    },
    {
      label: <StyledLink to={''}>Products</StyledLink>,
      icon: <ScopesIcon />,
      itemIcon: <ArrowIcon />,
      key: '',
      style: {
        paddingLeft: '15px',
      },
      children: [
        {
          label: <Link to={'/admin/products'}>Product Settings</Link>,
          key: 'products',
        },
        {
          label: <Link to={'/admin/systems'}>Systems Settings</Link>,
          key: 'system-settings',
        },
        {
          label: <Link to={'/admin/categories'}>Categories Settings</Link>,
          key: 'categories-settings',
        },
      ],
    },

    {
      label: <StyledLink to={'/admin/invoices'}>Invoices</StyledLink>,
      icon: <InvoicesIcon />,
      itemIcon: <ArrowIcon />,
      key: 'invoices',
    },
    {
      label: <StyledLink to={'/admin/partners'}>Partners</StyledLink>,
      icon: <SystemsIcon />,
      itemIcon: <ArrowIcon />,
      key: 'partners',
    },
    {
      label: <StyledLink to={'/marketplace'}>Marketplace</StyledLink>,
      icon: <MarketplaceIcon />,
      itemIcon: <ArrowIcon />,
      key: 'marketplace',
    },
  ]

  const tenantRoutes = [
    {
      label: <StyledLink to={'/tenant/dashboard'}>Dashboard</StyledLink>,
      icon: <DashboardIcon />,
      itemIcon: <ArrowIcon />,
      key: 'dashboard',
    },
    {
      label: <StyledLink to={'/marketplace'}>Marketplace</StyledLink>,
      icon: <TenantsIcon />,
      itemIcon: <ArrowIcon />,
      key: 'tenants',
    },
    {
      label: <StyledLink to={'/tenant/subscriptions'}>Subscriptions</StyledLink>,
      icon: <SubscriptionsIcon />,
      itemIcon: <ArrowIcon />,
      key: 'subscriptions',
    },
    props.role === UserRoleEnum.TENANT_ADMIN
      ? {
          label: <StyledLink to={'/tenant/users'}>Users</StyledLink>,
          icon: <UsersIcon />,
          itemIcon: <ArrowIcon />,
          key: 'users',
        }
      : null,
    {
      label: <StyledLink to={'/tenant/settings'}>Settings</StyledLink>,
      icon: <SettingsIcon />,
      itemIcon: <ArrowIcon />,
      key: 'settings',
    },
  ]

  const onClick: MenuProps['onClick'] = (e) => {
    if (window.innerWidth < 1000) props.toggleCollapsed()
  }

  return (
    <>
      <Sider
        style={{
          height: 'calc(100% - 64px)',
          position: 'fixed',
          zIndex: 1000,
          top: 64,
          left: 0,
          backgroundColor: 'white',
        }}
        className={props.className}
      >
        <div
          className='flex flex-col overflow-y-auto overflow-x-hidden'
          style={{
            height: 'calc(100vh - 64px)',
          }}
        >
          <div>
            <Typography
              className='w-full px-4 my-3  uppercase '
              style={{ color: '#c7c7c7', fontWeight: 500, fontSize: 12 }}
            >
              Main Menu
            </Typography>
            <Menu
              className='border-0'
              defaultOpenKeys={['sub1']}
              mode='inline'
              theme='light'
              inlineCollapsed={false}
              items={props.role === UserRoleEnum.ADMIN ? adminRoutes : tenantRoutes}
              onClick={onClick}
            ></Menu>
          </div>

          <div className='p-2 pb-5 m-2	' style={{ height: 350 }}>
            <CreateReportsWithSaas />
            {/* <SupportSection /> */}
          </div>
        </div>
      </Sider>
    </>
  )
}
